<template>
  <div class="tab-container">
    <div class="design">
      <div class="position-title">{{ calc_calculation_title }}</div>
      <div class="savings">
        <div class="savings-title">
          {{ uppercase(calc_savings_title) }}
        </div>
        <div class="euro">
          {{
            app_math.numberWithCommas(get_final_calculation.existing.cena - get_final_calculation.new.cena)
          }}&nbsp;<span v-html="currency_value" />
        </div>
        <div class="savings-kwh">
          {{
            app_math.numberWithCommas(
              settings.show_potrebno
                ? get_final_calculation.existing.final - get_final_calculation.new.final
                : get_final_calculation.existing.final_grejanje - get_final_calculation.new.final_grejanje
            )
          }}&nbsp;kWh
        </div>
        <div class="disclaimer">
          {{ calc_disclaimer_title }}
        </div>
      </div>
      <div class="consumption">
        <div class="consumption-title">{{ uppercase(calc_consumption_title) }}</div>
        <table>
          <tr>
            <td class="first-col"></td>
            <td class="second-col">{{ uppercase(calc_existing_title) }}</td>
            <td class="third-col">{{ uppercase(calc_intervention_title) }}</td>
          </tr>
          <template v-for="(row_type, index) in calc_order_value.split(';')">
            <tr v-if="row_type === 'E'" :key="row_type">
              <td :class="['first-col-1', 'third', index === 0 ? 'row-first' : '']">
                <span v-html="currency_value" />
              </td>
              <td class="second-col-1 third">
                {{ app_math.numberWithCommas(get_final_calculation.existing.cena) }}
              </td>
              <td class="third-col-1 third">
                {{ get_intervention_exists ? app_math.numberWithCommas(get_final_calculation.new.cena) : "- - - - -" }}
              </td>
            </tr>
            <tr v-if="row_type === 'H'" :key="row_type">
              <td :class="['first-col-1', index === 0 ? 'row-first' : '']">
                {{ calc_heat_title }}
                <p class="kwh">(kWh)</p>
              </td>
              <td class="second-col-1">
                {{
                  app_math.numberWithCommas(
                    settings.show_potrebno
                      ? get_final_calculation.existing.final
                      : get_final_calculation.existing.final_grejanje
                  )
                }}
              </td>
              <td class="third-col-1">
                {{
                  get_intervention_exists
                    ? app_math.numberWithCommas(
                        settings.show_potrebno
                          ? get_final_calculation.new.final
                          : get_final_calculation.new.final_grejanje
                      )
                    : "- - - - -"
                }}
              </td>
            </tr>
            <tr v-if="row_type === 'C'" :key="row_type">
              <td :class="['first-col-1', 'second', index === 0 ? 'row-first' : '']">
                CO<sub>2</sub>
                <p class="kwh second">(kg)</p>
              </td>
              <td class="second-col-1 second">
                {{ app_math.numberWithCommas(get_final_calculation.existing.co2) }}
              </td>
              <td class="third-col-1 second">
                {{ get_intervention_exists ? app_math.numberWithCommas(get_final_calculation.new.co2) : "- - - - -" }}
              </td>
            </tr>
            <tr v-if="index !== calc_order_value.split(';').length - 1" class="spacer-8" :key="row_type + '_spacer'">
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-else class="spacer-15" :key="row_type + '_spacer'">
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </template>
        </table>
      </div>
      <form target="_blank" method="GET" :action="calc_cta" id="myForm">
        <input type="hidden" name="json" :value="getJson" />
        <!-- font size u zavisnosti od drzave -->
        <input type="submit" class="offer" :value="calc_offer_title" :style="{ fontSize: ctaFontSize }" />
      </form>

      <div class="routing">
        <div class="img-back" @click="routechange(3)">
          <img src="../assets/images/Strelica_Back.svg" alt="left" />
        </div>
        <div class="text-back" @click="routechange(3)">
          {{ app_back }}
        </div>
        <div class="img-again" @click="$emit('start_again')">
          <img src="../assets/images/reload.svg" alt="left" />
        </div>
        <div class="text-again">
          <div class="again" @click="$emit('start_again')">
            {{ calc_again_title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-container {
  background-color: $lighter_background;

  .design {
    .position-title {
      font-size: 2rem;
      padding: 1.8rem 0;
      text-align: center;
      line-height: 2.6rem;
      color: $calc_back;
      font-family: "F-Dem";
      font-weight: bold;
    }

    .savings {
      background-color: $darker_background;
      border-top-left-radius: 4rem;
      border-top-right-radius: 4rem;
      padding-bottom: 5.4rem;

      .savings-title {
        font-family: F-Dem;
        font-size: 1.7rem;
        font-weight: bold;
        line-height: 1;
        text-align: center;
        padding: 2.1rem 0 1.5rem 0;
        color: $text_dark;
      }

      .euro {
        font-family: F-Dem;
        font-size: 6rem;
        font-weight: bold;
        line-height: 1.2;
        text-align: center;
        color: $typ_back;
        margin-bottom: 1.4rem;
      }

      .savings-kwh {
        font-family: F-Std;
        font-size: 3.6rem;
        line-height: 1.2;
        text-align: center;
        color: $calc_back;
        margin-bottom: 1.7rem;
      }

      .disclaimer {
        font-family: F-Std;
        font-size: 1.2rem;
        line-height: 1.33;
        text-align: center;
        color: $text_dark;
        padding: 0 4.6rem;
        margin-bottom: 1.7rem;
      }
    }

    .consumption {
      background-color: $lighter_background;
      border-top-left-radius: 4rem;
      border-top-right-radius: 4rem;
      margin-top: -4rem;
      padding-bottom: 3rem;
      padding-top: 3rem;

      .consumption-title {
        font-family: F-Dem;
        font-size: 1.7rem;
        line-height: 1.29;
        letter-spacing: 0.55px;
        text-align: center;
        padding: 2.7rem 0 2rem 0;
        margin-top: -4rem;
      }

      table {
        table-layout: fixed;
        border: none;
        width: 86%;
        margin: auto;
        border-collapse: collapse;

        .first-col {
          width: 28%;
        }

        .second-col {
          width: 36%;
          font-family: F-Dem;
          font-size: 1.2rem;
          line-height: 1.33;
          letter-spacing: 0.29px;
          text-align: center;
          color: $text_dark;
          padding: 0.6rem 0.5rem;
        }

        .third-col {
          width: 36%;
          font-family: F-Dem;
          font-size: 1.2rem;
          line-height: 1.33;
          letter-spacing: 0.29px;
          text-align: center;
          color: $text_dark;
          padding: 0.6rem 0.5rem;
        }

        .first-col-1 {
          font-family: F-Dem;
          font-size: 1.6rem;
          font-weight: bold;
          line-height: 1;
          color: $calc_back;
          text-align: center;
          background-color: $darker_background;

          .kwh {
            font-family: F-Std;
            font-size: 1.4rem;
            font-weight: 100;
            line-height: 1.36;
            text-align: center;
            padding-top: 0.2rem;

            &.second {
              margin-top: -0.5rem;
              padding-top: 0;
            }
          }

          &.second {
            line-height: 1.2;
            font-size: 2rem;
            color: $text_dark;
          }

          &.third {
            line-height: 1.2;
            font-size: 2.2rem;
            color: $typ_back;
          }

          &.row-first {
            padding: 3.7rem 0;
          }
        }

        .second-col-1 {
          background-color: $calc_back_light;
          font-family: F-Std;
          font-size: 1.6rem;
          line-height: 1.19;
          text-align: center;
          color: $text_white;
          vertical-align: middle;
          padding: 2.2rem 0;

          &.second {
            background-color: $text_pos_light;
          }

          &.third {
            background-color: #5dd191;
          }
        }

        .third-col-1 {
          font-family: F-Std;
          font-weight: bold;
          vertical-align: middle;
          background-color: $calc_back;
          font-size: 1.8rem;
          line-height: 1.33;
          letter-spacing: normal;
          text-align: center;
          color: $text_white;

          &.second {
            background-color: $text_dark;
          }

          &.third {
            background-color: $typ_back;
          }
        }

        .spacer-8 {
          height: 0.8rem;
        }

        .spacer-15 {
          height: 1.5rem;
        }

        .first-col-last {
          font-size: 2rem;
          line-height: 1.1;
          text-align: center;
          color: $text_dark;
          vertical-align: middle;
        }

        .second-col-last,
        .third-col-last {
          text-align: left;
          position: relative;

          svg {
            max-width: 90%;
            width: 90%;
          }

          img {
            position: absolute;
            z-index: 1;
            top: 15%;
            height: 70%;
            left: 0.8rem;
          }
        }
      }
    }

    .offer {
      width: 86%;
      padding: 2rem 0;
      text-align: center;
      color: $text_white;
      background-color: $calc_back;
      border-radius: 3.2rem;
      // font size is overwritten inline depending on country
      font-size: 2.3rem;
      line-height: 1.3;
      letter-spacing: 0.58px;
      margin: auto auto 2.4rem auto;
      border: none;
      height: auto;
      display: block;
      font-weight: normal;
    }

    .routing {
      display: flex;
      padding: 0 3rem;
      font-family: F-Std;
      font-size: 1.8rem;
      line-height: 1.22;
      letter-spacing: 0.45px;
      text-align: left;
      color: $text_back;
      margin-bottom: 2.2rem;

      .text-back {
        flex: 1 0 35%;
        padding-left: 1rem;
      }

      .text-again {
        flex: 1 0 45%;
        padding-left: 1rem;
      }

      .again {
        color: $calc_back;
      }
    }
  }
}
</style>

<script>
import app_math from "../lib/math.js";
import mixin from "../lib/mixins.js";
import settings from "../Settings";

export default {
  props: [
    "app_back",
    "app_finish",
    "get_final_calculation",
    "get_povrsine",
    "get_pos_status_u",
    "calc_calculation_title",
    "calc_existing_title",
    "calc_intervention_title",
    "calc_heat_title",
    "calc_energy_title",
    "calc_offer_title",
    "calc_again_title",
    "calc_consumption_title",
    "calc_savings_title",
    "calc_disclaimer_title",
    "pos_status",
    "app_country_materijal",
    "get_intervention_exists",
    "calc_order_value",
    "currency_value",
    "get_ordered_construction",
    "app_locales",
    "app_language",
    "loc_country",
  ],
  mixins: [mixin],
  data: function () {
    return {
      app_math: app_math,
      settings: settings,
    };
  },
  computed: {
    getJson: function () {
      const json = [];
      for (const pozicija in this.pos_status.value) {
        if (
          pozicija != 10 &&
          pozicija != 13 &&
          this.pos_status.value.hasOwnProperty(pozicija) &&
          this.pos_status.value[pozicija].status == 1
        ) {
          const value = this.pos_status.value[pozicija];
          json.push({
            povrsina_sprata: this.get_povrsine.B["povrsina_jednog_sprata"].toFixed(2),
            pozicija: this.getTitle(pozicija),
            povrsina: this.get_povrsine.B[pozicija].toFixed(2),
            debljina: Math.round(value.bottom_debljina_izolacije * 100),
            materijali: this.app_country_materijal.data[value.top_image][
              value.bottom_image === "b" || value.bottom_image === "c" ? value.bottom_image : "b"
            ],
          });
        }
      }

      return JSON.stringify(json);
    },

    ctaFontSize: function() {
      if (this.loc_country.value == "gr") {
        return "1.3rem";
      }
      return false;
    },
  },

  methods: {
    routechange: function (index) {
      this.$emit("route_change", index);
    },
    get_energy_color(energy) {
      if (energy === "G") return "#d2171e";
      if (energy === "F") return "#ff400e";
      if (energy === "E") return "#fe7309";
      if (energy === "D") return "#f9a51a";
      if (energy === "C") return "#f9ea1a";
      if (energy === "B") return "#a9d82a";
      if (energy === "A") return "#2db46a";
      if (energy === "A+") return "#179249";
    },
    getTitle: function (key) {
      const elem = this.get_ordered_construction.find((value) => value.key == key);
      return elem.title;
    },
  },
};
</script>
